import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    armasPersonal: [],
  },

  getters: {
    getArmasPersonal: (state) => state.armasPersonal,
  },

  mutations: {
    SET_ARMAS_PERSONAL: (state, armasPersonal) => {
      state.armasPersonal = armasPersonal;
    },

    UPDATE_ARMA_PERSONAL_STATUS: (state, armaPersonal) => {
      state.armasPersonal[state.armasPersonal
        .indexOf(armaPersonal.armaPersonal)].Arma.fk_idEstatus = armaPersonal.nuevoEstatus;
    },
  },

  actions: {
    async fetchArmasPersonal({ commit }, idPersonal) {
      await axios
        .get(`PoliciaCuadrantes/Armeria/personal/${idPersonal}/armas`)
        .then((response) => {
          commit('SET_ARMAS_PERSONAL', response.data.data);
        });
    },

    async saveArmaPersonal(_, armaPersonal) {
      await axios.post(`PoliciaCuadrantes/Armeria/personal/${armaPersonal.fk_idPersonal}/armas`, armaPersonal);
    },

    async updateEstatusArmaPersonal({ commit }, armaPersonal) {
      let nuevoEstatus;
      if (armaPersonal.Arma.fk_idEstatus === 1) {
        nuevoEstatus = 2;
      } else {
        nuevoEstatus = 1;
      }

      await axios.put(`PoliciaCuadrantes/Armeria/armas/${armaPersonal.Arma.idArma}`, {
        fk_idModelo: armaPersonal.Arma.fk_idModelo,
        fk_idClase: armaPersonal.Arma.fk_idClase,
        fk_idCalibre: armaPersonal.Arma.fk_idCalibre,
        fk_idEstatus: nuevoEstatus,
        fk_idSede: armaPersonal.Arma.fk_idSede,
        serie: armaPersonal.Arma.serie,
        folio: armaPersonal.Arma.folio,
        folioC: armaPersonal.Arma.folioC,
        folioD: armaPersonal.Arma.folioD,
        matricula: armaPersonal.Arma.matricula,
        loc: armaPersonal.Arma.loc,
        noEconomico: armaPersonal.Arma.noEconomico,
        ubicacion: armaPersonal.Arma.ubicacion,
        fechaAltaLoc: armaPersonal.Arma.fechaAltaLoc,
      });
      commit('UPDATE_ARMA_PERSONAL_STATUS', { armaPersonal, nuevoEstatus });
    },
  },
};
